import type { TonyteActivity, TonyteUser } from '../types';

export type ManageEventUser = Partial<TonyteUser> & { uid?: string | null };

export function canManageEvent(currentUser: ManageEventUser | null | undefined, event: TonyteActivity | null | undefined) {
  const currentUserId = currentUser?.uid || currentUser?.id;
  const ownerIds = [
    (event as any)?.createdBy,
    (event as any)?.hostId,
    (event as any)?.organizerId,
    (event as any)?.uploadedBy,
    (event as any)?.creatorId,
  ].filter(Boolean);
  const isOwner = Boolean(currentUserId && ownerIds.includes(currentUserId));
  const isAdmin = currentUser?.role === 'admin' || currentUser?.role === 'co-admin';
  return isAdmin || isOwner;
}
